module.exports = __webpack_public_path__ + "img/trx.54492e12.png";